import { Text } from 'platform-components';
import React from 'react';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const StudentAttempts = (props: { children: React.ReactNode }) => {
    return (
        <StatItem>
            <Text id="studentLessonStat.spentAttempts" />
            <span className="lesson-content__stat-detail-value qa_stat-detail-attempts">{props.children}</span>
        </StatItem>
    );
};
